import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { dashboardAPI, apiService } from '../api';

const PackagePatients = () => {
  const { campId, packageId } = useParams();
  const navigate = useNavigate();
  const [patients, setPatients] = useState([]);
  const [packageInfo, setPackageInfo] = useState(null);
  const [campInfo, setCampInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [originalPatients, setOriginalPatients] = useState([]);
  const [editingPatient, setEditingPatient] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState({ name: '', age: '', gender: '', phone: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch camp details to get camp name and packages
        const campDetails = await dashboardAPI.getCampDetails(campId);
        setCampInfo(campDetails);

        // Find the selected package from camp details
        const pkg = campDetails.packages?.find(p => p.id.toString() === packageId);
        setPackageInfo(pkg || null);

        // Fetch patients for this package
        const patientData = await dashboardAPI.getPackagePatients(campId, packageId);
        setPatients(patientData);
        setOriginalPatients(patientData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [campId, packageId]);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    if (term === '') {
      setPatients(originalPatients);
    } else {
      setPatients(originalPatients.filter(patient =>
        patient.name.toLowerCase().includes(term) ||
        patient.unique_patient_id.toLowerCase().includes(term) ||
        patient.phone.includes(term)
      ));
    }
  };

//   const handlePrintQR = (patient) => {
//     // Same printQR logic you already have in Dashboard
//     const printWindow = window.open('', '_blank');
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Patient Details - ${patient.name}</title>
//           <style>
//             body { font-family: Arial, sans-serif; padding: 20px; }
//             .patient-card { border: 1px solid #ddd; padding: 20px; margin: 10px 0; border-radius: 8px; }
//             .qr-code { max-width: 200px; margin: 10px 0; }
//           </style>
//         </head>
//         <body>
//           <div class="patient-card">
//             <h2>Patient Details</h2>
//             <p><strong>Name:</strong> ${patient.name}</p>
//             <p><strong>Patient ID:</strong> ${patient.unique_patient_id}</p>
//             <p><strong>Age:</strong> ${patient.age}</p>
//             <p><strong>Gender:</strong> ${patient.gender}</p>
//             <p><strong>Phone:</strong> ${patient.phone}</p>
//             <p><strong>Services:</strong> ${patient.services.join(', ')}</p>
//             <div>
//               <strong>QR Code:</strong><br>
//               <img src="${patient.qr_code_url}" alt="QR Code" class="qr-code">
//             </div>
//           </div>
//           <script>window.print();</script>
//         </body>
//       </html>
//     `);
//   };


const handleSendMessage = async (patient) => {
    try {
      const response = await fetch(`https://backend.xraidigital.com/api/campmanager/send-registration-sms/${patient.id}/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ camp_id: campId }),
      });
      if (response.ok) {
        alert('Message sent successfully!');
      } else {
        alert('Failed to send message.');
      }
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Error sending message.');
    }
  };


//  const handleBulkSendMessage = async () => {
//     if (!window.confirm(`Are you sure you want to send messages to all ${originalPatients.length} patients?`)) return;

//     let successCount = 0;
//     for (const patient of originalPatients) {
//       try {
//         const response = await fetch(`https://backend.xraidigital.com/api/campmanager/send-registration-sms/${patient.id}/`, {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ camp_id: campId }),
//         });
//         if (response.ok) successCount++;
//       } catch (error) {
//         console.error('Error sending message:', error);
//       }
//     }
//     alert(`Messages sent successfully to ${successCount} patients.`);
    
//   }
const handleOpenMessagePage = (patient) => {
   console.log('Navigating to message page for patient:', patient);
    // Open an internal page where coordinator can upload photo and send message
    navigate(`/patient-message/${patient.unique_patient_id}`, { state: { patient, campInfo, packageInfo } });
  }


 const handleBulkSendMessage = () => {    
    originalPatients.forEach((patient) => {
        const message = `Hello ${patient.name}, your unique patient ID is ${patient.unique_patient_id}. Please visit the camp for your scheduled services.`;    
        const phoneNumber = patient.phone.replace(/\D/g, '');
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    });
  } 


    const handleUpdatedDetail = (patient) => {
      setEditingPatient(patient);
      setEditForm({
        name: patient.name || '',
        age: patient.age || '',
        gender: patient.gender || '',
        phone: patient.phone || ''
      });
      setShowEditModal(true);
    }

    const handleEditChange = (e) => {
      const { name, value } = e.target;
      setEditForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSaveUpdatedDetails = async () => {
      if (!editingPatient) return;
      setSaving(true);
      try {
        const formData = new FormData();
        formData.append('name', editForm.name);
        formData.append('age', editForm.age);
        formData.append('gender', editForm.gender);
        formData.append('phone', editForm.phone);

        const identifier = editingPatient.nirman_number || editingPatient.unique_patient_id;
        await apiService.northstar.updatePatient(identifier, formData);

        setPatients(prev => prev.map(p => p.id === editingPatient.id ? { ...p, ...editForm } : p));
        setOriginalPatients(prev => prev.map(p => p.id === editingPatient.id ? { ...p, ...editForm } : p));

        setShowEditModal(false);
        setEditingPatient(null);
      } catch (error) {
        console.error('Error updating patient:', error);
        alert('Failed to update patient details.');
      } finally {
        setSaving(false);
      }
    }; 

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ border: '4px solid #e5e7eb', borderTop: '4px solid #11a8a4', borderRadius: '50%', width: '36px', height: '36px', animation: 'spin 1s linear infinite', margin: 'auto' }}></div>
          <p style={{ marginTop: '12px', color: '#6b7280' }}>Loading patients...</p>
        </div>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6' }}>
      {/* Header */}
      <div style={{ backgroundColor: '#ffffff', padding: '16px 24px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <button
            onClick={() => navigate(-1)}
            style={{ background: 'none', border: 'none', color: '#11a8a4', cursor: 'pointer', fontSize: '14px', fontWeight: '500', padding: 0, marginBottom: '4px' }}
          >
            ← Back to Camp
          </button>
          <h1 style={{ fontSize: '22px', fontWeight: 'bold', color: '#1f2937', margin: 0 }}>
            Patients - {packageInfo?.name || 'Package'}
          </h1>
          <p style={{ color: '#6b7280', fontSize: '14px', margin: '4px 0 0 0' }}>
            Camp: {campInfo?.location || ''} (ID: {campId}) | Package ID: {packageId}
          </p>
        </div>
        {/* bulk send message button can be added here in future */}
        <div>
            <button
                onClick={handleBulkSendMessage}
                style={{ backgroundColor: '#11a8a4', color: '#ffffff', border: 'none', borderRadius: '6px', padding: '8px 16px', cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}
            >
                Send Message to All
            </button>
        </div>

        {/* Search */}
        <div style={{ position: 'relative', width: '300px' }}>
          <input
            type="text"
            placeholder="Search patients..."
            value={searchTerm}
            onChange={handleSearch}
            style={{ width: '100%', padding: '8px 12px 8px 32px', border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
          />
          <svg style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#9ca3af' }} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
      </div>

      {/* Patient List */}
      <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
        {patients.length === 0 ? (
          <div style={{ backgroundColor: '#f3f4f6', padding: '40px', borderRadius: '8px', textAlign: 'center', border: '1px dashed #e5e7eb' }}>
            <p style={{ color: '#6b7280' }}>{searchTerm ? 'No matching patients found' : 'No patients found for this package'}</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {patients.map(patient => (
              <div key={patient.id} style={{ border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#ffffff' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                    <p style={{ margin: 0, fontWeight: '600', fontSize: '16px', color: '#1f2937' }}>{patient.name}</p>
                    <span style={{ backgroundColor: '#e5e7eb', color: '#3c3b3f', padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '500' }}>
                      ID: {patient.unique_patient_id}
                    </span>
                  </div>
                  <div style={{ marginTop: '8px', display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: '14px', color: '#6b7280' }}>Age: {patient.age}</span>
                    <span style={{ fontSize: '14px', color: '#6b7280' }}>Gender: {patient.gender}</span>
                    <span style={{ fontSize: '14px', color: '#6b7280' }}>Phone: {patient.phone}</span>
                  </div>
                  <div style={{ marginTop: '4px' }}>
                    <span style={{ fontSize: '14px', color: '#6b7280' }}>Services: {patient.services.join(', ')}</span>
                  </div>
                </div>
                <button
                  onClick={() => handleUpdatedDetail(patient)}
                  style={{ backgroundColor: '#3b82f6', color: '#ffffff', border: 'none', borderRadius: '6px', padding: '8px 16px', cursor: 'pointer', fontWeight: '500', fontSize: '14px', marginRight: '12px' }}       
                >
                  Updated Details
                </button>
                <button
                  onClick={() => handleSendMessage(patient)}
                  // onClick={() => handleOpenMessagePage(patient)}
                  style={{ backgroundColor: '#11a8a4', color: '#ffffff', border: 'none', borderRadius: '6px', padding: '8px 16px', cursor: 'pointer', fontWeight: '500', fontSize: '14px' }}
                >
                  Send Message
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {showEditModal && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '8px', minWidth: '320px', maxWidth: '600px' }}>
            <h2 style={{ margin: 0, marginBottom: 12 }}>Update Patient</h2>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <input name="name" value={editForm.name} onChange={handleEditChange} placeholder="Name" style={{ padding: '8px', borderRadius: '6px', border: '1px solid #e5e7eb' }} />
              <input name="age" value={editForm.age} onChange={handleEditChange} placeholder="Age" style={{ padding: '8px', borderRadius: '6px', border: '1px solid #e5e7eb' }} />
              <input name="gender" value={editForm.gender} onChange={handleEditChange} placeholder="Gender" style={{ padding: '8px', borderRadius: '6px', border: '1px solid #e5e7eb' }} />
              <input name="phone" value={editForm.phone} onChange={handleEditChange} placeholder="Phone" style={{ padding: '8px', borderRadius: '6px', border: '1px solid #e5e7eb' }} />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '12px' }}>
              <button onClick={() => { setShowEditModal(false); setEditingPatient(null); }} style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e5e7eb', background: '#fff' }}>Cancel</button>
              <button onClick={handleSaveUpdatedDetails} disabled={saving} style={{ padding: '8px 12px', borderRadius: '6px', border: 'none', background: '#11a8a4', color: '#fff' }}>{saving ? 'Saving...' : 'Save'}</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default PackagePatients;